export const FEE_RATE_OPTIONS = [
  { label: '10.0%', value: '0.1' },
  { label: '13.6%', value: '0.136' },
]
